import React from "react";
import { LongTextLabel } from "@sscs/ui";
import { RemovalStatus } from "Components";
import { PortalFile } from "Types";
import UploadedByInfo from "../UploadedByInfo/UploadedByInfo";
import styles from "./fileStreamStatusText.module.scss";

type FileStreamStatusTextProps = {
  file: PortalFile | undefined;
};

const FileStreamStatusText = ({
  file,
}: FileStreamStatusTextProps): React.JSX.Element | null => {
  if (!file) return null;

  return (
    <div>
      <div className={styles["status-text"]}>
        Report for{" "}
        <LongTextLabel label={file.file_name} className={styles["file-name"]} />
        {file.days_until_deletion !== undefined && (
          <>
            will be{" "}
            <RemovalStatus
              daysUntilDeletion={file.days_until_deletion}
              prefixRemovedToday="removed"
              prefixRemovedInDays="removed in"
            />
          </>
        )}
      </div>
      <div>
        <UploadedByInfo user={file.user} importedFrom={file.imported_from} />
      </div>
    </div>
  );
};

export default FileStreamStatusText;
